exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Select__Select--zn-IS {\n    margin-bottom: 15px;\n}\n\n.Select__Select--zn-IS label {\n    margin: 0 0 3px 0;\n    padding: 0;\n    font-weight: bold;\n    display: block;\n}\n\n.Select__Select--zn-IS select {\n    display: block;\n    box-sizing: border-box;\n    border: 1px solid #bebebe;\n    margin: 0 0 5px;\n    height: 29px;\n    width: 100%;\n    outline: none;\n    transition: all 300ms ease-in-out;\n}", ""]);

// exports
exports.locals = {
	"Select": "Select__Select--zn-IS"
};